let TOTAL_AGENDA_VIEWPORT_HEIGHT = 0;
const AGENDA_VIEW_SELECTOR = '.agenda-view';

/**
 * Function to extract agenda height
 */
export default function getAgendaHeight() {
    if (!TOTAL_AGENDA_VIEWPORT_HEIGHT) {
        const agendaViewElement = document.querySelector(AGENDA_VIEW_SELECTOR);
        TOTAL_AGENDA_VIEWPORT_HEIGHT = agendaViewElement ? agendaViewElement.clientHeight : 0;
    }
    return TOTAL_AGENDA_VIEWPORT_HEIGHT;
}
